import _ from '@app/utils.js'

// Durata dell'animazione di chiusura: deve corrispondere a $menu-anim-duration in index.scss.
const CLOSE_DURATION = 400

_.onElementArrive('header', header => {
  const body = document.querySelector('body');
  const menu = header.querySelector('.main-menu');

  const backdrop = document.createElement('div')
  backdrop.classList.add('menu-backdrop')
  body.appendChild(backdrop)

  const myDiemmebiMenu = header.querySelector('.my-diemmebi-menu')
  const langMenu = header.querySelector('.language-menu-panel')

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  let closingTimer = null
  let openingTimer = null

  // Reset istantanei dei singoli pannelli, senza toccare lo stato del body.
  const resetMainMenu = () => {
    const activeLi = menu.querySelector('.level-1 > li.open')
    if (activeLi) {
      activeLi.style.minHeight = '0'
      activeLi.classList.remove('open')
    }
  }

  const resetMyDiemmebi = () => {
    if (myDiemmebiMenu) myDiemmebiMenu.classList.remove('header-submenu-open')
  }

  const resetLangMenu = () => {
    if (langMenu) langMenu.classList.remove('header-submenu-open')
  }

  const isClosing = () => body.classList.contains('menu-closing')

  const cancelClosing = () => {
    clearTimeout(closingTimer)
    body.classList.remove('menu-closing')
  }

  const resetAll = () => {
    cancelClosing()
    resetMainMenu()
    resetMyDiemmebi()
    resetLangMenu()
    clearTimeout(openingTimer)
    body.classList.remove('menu-open', 'menu-opening')
  }

  // menu-opening abilita l'animazione dei contenuti solo nel passaggio da chiuso ad aperto.
  const openPanel = () => {
    const wasOpen = body.classList.contains('menu-open') && !isClosing()
    cancelClosing()
    body.classList.add('menu-open')
    if (wasOpen) {
      clearTimeout(openingTimer)
      body.classList.remove('menu-opening')
      return
    }
    body.classList.add('menu-opening')
    clearTimeout(openingTimer)
    openingTimer = setTimeout(() => body.classList.remove('menu-opening'), CLOSE_DURATION * 2)
  }

  // Chiusura animata: il pannello risale e il backdrop sfuma, poi si resettano i sottomenu.
  const closeAll = () => {
    if (!body.classList.contains('menu-open') || isClosing()) return
    body.classList.add('menu-closing')
    closingTimer = setTimeout(resetAll, reducedMotion.matches ? 0 : CLOSE_DURATION)
  }

  menu.querySelectorAll('.level-1 > li > span').forEach(menuSpanItem => {
    menuSpanItem.addEventListener('click', () => {
      const selectedLi = menuSpanItem.parentNode
      if (selectedLi.classList.contains('open') && !isClosing()) {
        closeAll()
        return
      }

      resetMyDiemmebi()
      resetLangMenu()
      resetMainMenu()
      selectedLi.classList.add('open')
      const selectedLiUl = selectedLi.querySelector('ul, .level-2')
      if (selectedLiUl) {
        selectedLi.style.minHeight = (30 + selectedLiUl.clientHeight) + 'px'
      }
      openPanel()
    })
  })

  header.querySelectorAll('[data-open-registration-modal]').forEach(el => {
    el.addEventListener('click', resetAll)
  })

  backdrop.addEventListener('click', closeAll)

  menu.addEventListener('click', e => {
    if (e.target.closest('a[href*="#"]')) closeAll()
  })

  const bindSubmenuTrigger = (trigger, panel) => {
    if (!trigger || !panel) return
    trigger.addEventListener('click', () => {
      if (panel.classList.contains('header-submenu-open') && !isClosing()) {
        closeAll()
        return
      }
      resetMainMenu()
      resetMyDiemmebi()
      resetLangMenu()
      panel.classList.add('header-submenu-open')
      openPanel()
    })
  }

  bindSubmenuTrigger(header.querySelector('.my-diemmebi-trigger'), myDiemmebiMenu)
  bindSubmenuTrigger(header.querySelector('.language-trigger'), langMenu)



  // Aggiunge menu-transparent quando <header> si sovrappone a un .menu-overlay.
  // La rootMargin restringe la zona di intersezione alla sola fascia dell'header.
  const overlays = document.querySelectorAll('.menu-overlay');
  if (overlays.length) {
    const intersecting = new Set();

    const buildObserver = () => new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.isIntersecting ? intersecting.add(entry.target) : intersecting.delete(entry.target);
      });
      body.classList.toggle('menu-transparent', intersecting.size > 0);
    }, {
      rootMargin: `-100px 0px -${window.innerHeight - header.offsetHeight}px 0px`,
      threshold: 0,
    });

    let overlayObserver = buildObserver();
    overlays.forEach(el => overlayObserver.observe(el));

    window.addEventListener('resize', () => {
      overlayObserver.disconnect();
      intersecting.clear();
      overlayObserver = buildObserver();
      overlays.forEach(el => overlayObserver.observe(el));
    });
  }
})
